import { ITableHeader } from '../../../../../Invoices/InvoiceHub/components/Table/types';

export const BILLS_TABLE_COLUMN_KEYS = {
  BILL_NUMBER: 'billNumber',
  VENDOR_NAME: 'vendor',
  DUE_DATE: 'dueDate',
  STATUS: 'calculatedStatus',
  ATTACHMENT: 'attachment',
  AMOUNT: 'amount',
  ACTION: 'action',
};

export const BILLS_TABLE_COLUMNS: Array<ITableHeader> = [
  { title: 'BILL_PAY.BILLS_HUB.COLUMN_HEADER.BILL_NUMBER', key: 'billNumber' },
  { title: 'BILL_PAY.BILLS_HUB.COLUMN_HEADER.VENDOR_NAME', key: 'vendor' },
  { title: 'BILL_PAY.BILLS_HUB.COLUMN_HEADER.DUE_DATE', key: 'dueDate' },
  { title: 'BILL_PAY.BILLS_HUB.COLUMN_HEADER.STATUS', key: 'calculatedStatus' },
  { title: 'BILL_PAY.BILLS_HUB.COLUMN_HEADER.ATTACHMENT', key: 'attachment' },
  { title: 'BILL_PAY.BILLS_HUB.COLUMN_HEADER.AMOUNT', key: 'amount' },
  { title: 'BILL_PAY.BILLS_HUB.COLUMN_HEADER.ACTION', key: 'action' },
];
